/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Annex = {

	delete (context, projectId, onSuccess, onError, options) {
		Api.delete(context,
			"/annex"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteApplication (context, projectId, onSuccess, onError, options) {
		Api.delete(context,
			"/annex/application"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteAttachment (context, projectId, annexId, attachmentId, type, onSuccess, onError, options) {
		Api.delete(context,
			"/annex/attachment"
			+ "?projectId=" + projectId
			+ "&annexId=" + annexId
			+ "&attachmentId=" + attachmentId
			+ "&type=" + type
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, annexId, onSuccess, onError, options) {
		Api.get(context,
			"/annex"
			+ "?annexId=" + annexId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, file, attachments, signDate, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/annex"
			+ "?file=" + file
			+ "&attachments=" + attachments
			+ "&signDate=" + signDate
			+ "&projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAnnexAttachment (context, annexFile, projectId, annexId, onSuccess, onError, options) {
		Api.post(context,
			"/annex/annex-attachment"
			+ "?annexFile=" + annexFile
			+ "&projectId=" + projectId
			+ "&annexId=" + annexId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postApplication (context, file, attachments, number, signDate, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/annex/application"
			+ "?file=" + file
			+ "&attachments=" + attachments
			+ "&number=" + number
			+ "&signDate=" + signDate
			+ "&projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postApplicationAttachment (context, annexFile, projectId, annexId, onSuccess, onError, options) {
		Api.post(context,
			"/annex/application-attachment"
			+ "?annexFile=" + annexFile
			+ "&projectId=" + projectId
			+ "&annexId=" + annexId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postUpdateAnnexFile (context, file, projectId, annexId, isApplication, onSuccess, onError, options) {
		Api.post(context,
			"/annex/update-annex-file"
			+ "?file=" + file
			+ "&projectId=" + projectId
			+ "&annexId=" + annexId
			+ "&isApplication=" + isApplication
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAnnexRemarks (context, projectId, newContentDTO, onSuccess, onError, options) {
		Api.put(context,
			"/annex/annex-remarks"
			+ "?projectId=" + projectId
			, newContentDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putApplicationData (context, projectId, annexId, signDate, number, onSuccess, onError, options) {
		Api.put(context,
			"/annex/application-data"
			+ "?projectId=" + projectId
			+ "&annexId=" + annexId
			+ "&signDate=" + signDate
			+ "&number=" + number
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUpdateAnnexData (context, projectId, annexId, signDate, onSuccess, onError, options) {
		Api.put(context,
			"/annex/update-annex-data"
			+ "?projectId=" + projectId
			+ "&annexId=" + annexId
			+ "&signDate=" + signDate
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
